<template>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6">
        <VueInput
          :error="errors.title"
          label="Book title"
          v-model="modelValue.title"
        />

        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Book Category</label>
          <div class="col-sm-7">
            <v-select
              :options="fieldValues.topCategories"
              v-model="modelValue.top_category_id"
              label="title"
              @input="onCategoryChanged"
              :reduce="(category) => category.id"
              placeholder="Choose One"
            />
          </div>
        </div>

        <div class="form-group row" v-if="currentTopCategory.can_have_child">
          <label class="col-sm-5 col-form-label">Sub Category</label>
          <div class="col-sm-7">
            <v-select
              :options="fieldValues.subCategories"
              v-model="modelValue.sub_category_id"
              label="title"
              :reduce="(category) => category.id"
              @input="onCategoryChanged"
              placeholder="Select or create a sub-category"
              v-if="!createCategoryMode"
            >
            </v-select>
            <div v-if="createCategoryMode" class="row">
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  v-model="categoryName"
                  placeholder="Type sub-category name"
                />
                <div class="mt-10">
                  <button
                    class="btn btn-default"
                    @click="createCategoryMode = !createCategoryMode"
                  >
                    Cancel
                  </button>
                  <button
                    class="btn btn-primary pull-right"
                    @click="createSubCategory()"
                  >
                    Create Sub-category
                  </button>
                </div>
              </div>
            </div>

            <p
              v-if="!createCategoryMode && !isReadOnlyUser"
              class="input-switcher mt-10"
              @click="createCategoryMode = !createCategoryMode"
            >
              Create sub-category
            </p>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Visibility</label>
          <div class="col-sm-7">
            <p-radio
              class="p-default p-curve"
              color="primary"
              v-model="modelValue.visibility"
              value="public"
              >Public</p-radio
            >
            <p-radio
              class="p-default p-curve"
              color="danger"
              v-model="modelValue.visibility"
              value="private"
              >Private</p-radio
            >

            <p-radio
              class="p-default p-curve"
              color="secondary"
              v-model="modelValue.visibility"
              value="inactive"
              >Inactive</p-radio
            >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Order</label>
          <div class="col-sm-3" v-if="modelValue.id">
            <toggle-button
              v-model="modelValue.changeBookOrder"
              :value="modelValue.changeBookOrder"
            />
            Change order
          </div>
          <div class="col-sm-4">
            <p-radio
              class="p-default p-curve"
              color="primary"
              v-model="modelValue.bookReferenceLocation"
              value="before"
              :disabled="!modelValue.changeBookOrder"
              >Before</p-radio
            >
            <p-radio
              class="p-default p-curve"
              color="primary"
              v-model="modelValue.bookReferenceLocation"
              value="after"
              :disabled="!modelValue.changeBookOrder"
              >After</p-radio
            >
          </div>
        </div>

        <div class="form-group row">
          <label class="col-sm-5 col-form-label"></label>
          <div class="col-sm-7">
            <v-select
              :options="fieldValues.siblingBooks"
              v-model="modelValue.bookReferenceId"
              label="title"
              :disabled="!modelValue.changeBookOrder"
              :reduce="(book) => book.id"
              placeholder="Select a book"
            >
              <template v-slot:option="option">
                <span :class="option.icon"></span>
                {{ option.order }} - {{ option.title }}
              </template>
            </v-select>
            <p v-if="modelValue.id && modelValue.changeBookOrder">
              Current order {{ modelValue.order }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="accordion">
          <div class="accordion-item">
            <div class="accordion-header">
              <p-radio
                class="p-default p-curve"
                color="primary"
                name="cover"
                v-model="coverMode"
                value="image"
                >Upload a Cover Image</p-radio
              >
            </div>
            <div class="accordion-content" v-show="coverMode == 'image'">
              <div class="col-md-12 text-center file-upload-panel-container">
                <div
                  class="file-upload-element"
                  @click="showNativeUploadDialog()"
                >
                  <div
                    href="file-upload-placeholder"
                    v-if="!uploadComponent.displayPreviewImage"
                  >
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                    <span>Click Here To Select Image</span>
                  </div>
                  <img
                    class="file-upload-preview"
                    v-show="uploadComponent.displayPreviewImage"
                    ref="file-upload-preview"
                  />
                </div>
                <input
                  type="file"
                  name="image_url"
                  class="file-upload-input"
                  @change="loadChosenFile($event, 'de')"
                  ref="file-upload-input"
                />
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div class="accordion-header">
              <p-radio
                class="p-default p-curve"
                color="primary"
                name="cover"
                v-model="coverMode"
                value="image_en"
                >Upload an English Cover Image</p-radio
              >
            </div>
            <div class="accordion-content" v-show="coverMode == 'image_en'">
              <div class="col-md-12 text-center file-upload-panel-container">
                <div
                  class="file-upload-element"
                  @click="showNativeUploadDialogEN()"
                >
                  <div
                    href="file-upload-placeholder"
                    v-if="!uploadComponent.displayENPreviewImage"
                  >
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                    <span>Click Here To Select Image</span>
                  </div>
                  <img
                    class="file-upload-en-preview"
                    v-show="uploadComponent.displayENPreviewImage"
                    ref="file-upload-en-preview"
                  />
                </div>
                <input
                  type="file"
                  name="image_url"
                  class="file-upload-input"
                  @change="loadChosenFile($event, 'en')"
                  ref="file-upload-en-input"
                />
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div class="accordion-header">
              <p-radio
                class="p-default p-curve"
                color="primary"
                name="cover"
                v-model="coverMode"
                value="color"
                >Choose a Cover Image Color</p-radio
              >
            </div>
            <div class="accordion-content" v-show="coverMode == 'color'">
              <div class="row">
                <div class="col-md-2 text-center">
                  <h5>Selector</h5>
                  <v-input-colorpicker v-model="selectedCoverColor.value" />
                </div>
              </div>
              <hr />
              <div class="row predifined-color-container">
                <div
                  class="col-md-2 text-center color-selector-container"
                  v-for="color in fieldValues.predefinedColors"
                >
                  <span
                    @click="selectColor(color)"
                    class="color-selector"
                    v-bind:style="{ backgroundColor: color.value }"
                  ></span
                  ><br />
                  {{ color.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueInput from "@/pages/Tools/input";
import InputColorPicker from "vue-native-color-picker";

export default {
  components: {
    VueInput,
    "v-input-colorpicker": InputColorPicker,
  },
  data() {
    return {
      isReadOnlyUser: false,
      createCategoryMode: false,
      topCategoryId: null,
      categoryName: null,
      uploadComponent: {
        displayPreviewImage: false,
        displayENPreviewImage: false,
      },
      coverMode: "color",
      selectedImage: null,
      selectedENImage: null,
      selectedCoverColor: {
        name: "",
        value: null,
      },
    };
  },
  props: {
    fieldValues: {
      type: [Object],
      default: {},
    },
    modelValue: {
      type: [Object],
      default: {},
    },
    errors: {
      type: [Object],
      default: {},
    },
    bookCoverImage: {
      type: [String],
      default: null,
    },
    bookCoverENImage: {
      type: [String],
      default: null,
    },
    currentTopCategory: {
      type: [Object],
      default: {},
    },
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.topCategoryId = this.fieldValues.top_category_id;
    this.loadProvidedImage();
  },
  watch: {
    bookCoverImage: function () {
      if (this.bookCoverImage !== null) {
        this.loadProvidedImage();
      } else {
        this.resetPreview();
      }
    },
    bookCoverENImage: function () {
      if (this.bookCoverENImage !== null) {
        this.loadProvidedImage();
      } else {
        this.resetPreview();
      }
    },
  },
  methods: {
    async createSubCategory() {
      const form = new FormData();
      form.append("title", this.categoryName);
      form.append(
        "parent_fabric_book_category_id",
        this.modelValue.top_category_id
      );

      try {
        let response = await axios.post("v2/fabrics/book-category", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data.status === "OK") {
          this.modelValue.sub_category_id = response.data.data;
          this.$emit("sub-category-created");
          this.createCategoryMode = false;
          this.categoryName = "";
          toastr.success("Sub-category successfully created");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
          this.errors = error.response.data.errors;
        }
        window.scrollTo(0, 0);
      }
    },
    loadProvidedImage() {
      // This ref does not exist when the image upload panel is not displayed
      if (this.$refs["file-upload-preview"] && this.bookCoverImage) {
        this.uploadComponent.displayPreviewImage = true;
        this.$refs["file-upload-preview"].src = this.bookCoverImage;
      }

      if (this.$refs["file-upload-en-preview"] && this.bookCoverENImage) {
        this.uploadComponent.displayENPreviewImage = true;
        this.$refs["file-upload-en-preview"].src = this.bookCoverENImage;
      }
    },

    resetPreview() {
      this.uploadComponent.displayPreviewImage = false;
      this.uploadComponent.displayENPreviewImage = false;
      this.$refs["file-upload-preview"].src = null;
      this.$refs["file-upload-en-preview"].src = null;
    },

    showNativeUploadDialog() {
      let elem = this.$refs["file-upload-input"];
      elem.click();
    },

    showNativeUploadDialogEN() {
      let elem = this.$refs["file-upload-en-input"];
      elem.click();
    },

    loadChosenFile(event, localeType) {
      let self = this;
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = function (e) {
          if (localeType === "de") {
            self.uploadComponent.displayPreviewImage = true;
            self.$refs["file-upload-preview"].src = e.target.result;
          } else {
            self.uploadComponent.displayENPreviewImage = true;
            self.$refs["file-upload-en-preview"].src = e.target.result;
          }
        };
        reader.readAsDataURL(input.files[0]);
        if (localeType === "de") {
          this.$emit("cover-image-selected", input.files[0]);
          this.selectedImage = input.files[0];
        } else {
          this.$emit("en-cover-image-selected", input.files[0]);
          this.selectedENImage = input.files[0];
        }

        if (this.modelValue.id) {
          this.uploadCurrentImage(localeType);
        }
      }
    },

    async uploadCurrentImage(localeType) {
      if (this.selectedImage || this.selectedENImage) {
        show_modal("#cover-upload-modal");
        try {
          if (this.modelValue.selectedImage) {
            const form = new FormData();
            form.set("image", this.selectedImage);
            let response = await axios.post(
              `v2/fabrics/book/${this.modelValue.id}/cover/de`,
              form,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
          }

          if (this.modelValue.selectedENImage) {
            const form = new FormData();
            form.set("image_en", this.selectedENImage);
            let response = await axios.post(
              `v2/fabrics/book/${this.modelValue.id}/cover/en`,
              form,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
          }

          toastr.success("Fabric book cover successfully uploaded");
        } catch (error) {
          if (error.response.status === 422) {
            // Error triggered by request validation
            let errorMessage = error.response.data.message; // Set default error message
            if (error.response.data.errors.hasOwnProperty("image")) {
              errorMessage = error.response.data.errors["image"].join(", ");
            }
            if (error.response.data.errors.hasOwnProperty("image_en")) {
              errorMessage = error.response.data.errors["image_en"].join(", ");
            }
            toastr.error(errorMessage);
          } else if (error.response.status === 413) {
            // Error triggered by HTTP server (Apache/Nginx) configutation
            toastr.error("Image size is too large");
          } else if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error("Unknown error");
          }
        }

        hide_modal("#cover-upload-modal");
      }
    },

    onCategoryChanged(categoryId) {
      this.$emit("category-changed", categoryId);
    },
    selectColor(color) {
      this.selectedCoverColor.value = color.value;
      this.modelValue.book_cover_color = color.value;
    },
  },
};
</script>

<style scoped>
.input-switcher {
  left: 20px;
  font-size: 12px;
  color: var(--primary-color);
  cursor: pointer;
}
.accordion-header {
  width: 100%;
  text-align: left;
  padding: 10px 15px;
  border: 1px solid #d7d8da;
  font-weight: 600;
}
.accordion-content {
  padding: 20px;
  overflow: hidden;
  border: 1px solid #d7d8da;
  margin-top: -1px;
}

.accordion .accordion-item:nth-child(2) {
  margin-top: 5px;
}

.file-upload-panel-container {
  padding-top: 0px !important;
}

.file-upload-panel-container .file-upload-element {
  text-align: center;
  background: #eee;
  border: 2px dashed #ccc !important;
  min-height: 270px;
  max-height: 270px;
}

.file-upload-panel-container .file-upload-element:hover {
  border: 3px dashed #aaa !important;
}

.file-upload-panel-container .file-upload-element i {
  margin-top: 90px;
  font-size: 80px;
  display: block;
}

.file-upload-panel-container .file-upload-input {
  display: none;
}

.file-upload-panel-container button {
  margin-top: 10px;
  cursor: pointer;
}

.file-upload-panel-container .file-upload-preview {
  max-height: 266px;
  max-width: 100%;
}
.file-upload-panel-container .file-upload-en-preview {
  max-height: 266px;
  max-width: 100%;
}
.color-selector-container {
  margin-bottom: 25px;
}
.color-selector {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #555;
  cursor: pointer;
}
.icp__input {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 1px solid #555;
  padding: 0 !important;
  overflow: hidden;
}
</style>
